// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1lOZ4","buttons":"Footer_buttons__swpQp"};